export default "__VITE_ASSET__59e354c6__"